import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../stores/useAuthStore';
import axiosClient from '../services/api';

import boleumlogo from "../assets/boleumlogo.png";

const InstructorPendingVerificationPage = () => {
    const navigate = useNavigate();
    const { user } = useAuthStore();
    const [checkInterval, setCheckInterval] = useState(null);

    useEffect(() => {
        // Check for admin verification every 30 seconds
        const interval = setInterval(async () => {
            try {
                const response = await axiosClient.get('/users/onboarding');
                if (response.data.success && response.data.data.adminVerified) {
                    clearInterval(interval);
                    alert('Congratulations! Your instructor account has been verified. You can now create courses.');
                    navigate('/instructor/analytics');
                }
            } catch (error) {
                console.error('Error checking verification status:', error);
            }
        }, 30000);

        setCheckInterval(interval);

        return () => {
            if (checkInterval) {
                clearInterval(checkInterval);
            }
        };
    }, []);

    if (!user) {
        return (
            <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 py-8">
            <div className="max-w-4xl mx-auto px-4">
                <div className="flex items-center space-x-2 mb-8">
                    <img
                        src={boleumlogo}
                        alt="BoleumLearn Logo"
                        className="h-8 w-8 object-contain"
                    />

                    {/* Brand Text */}
                    <span className="text-2xl font-bold text-primary-600 dark:text-primary-400">
                        BoleumLearn
                    </span>
                </div>

            </div>
            <div className="max-w-4xl mx-auto px-4">
                <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm border border-neutral-200 dark:border-neutral-700 p-8 text-center">
                    <div className="w-24 h-24 bg-warning-100 dark:bg-warning-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
                        <svg className="w-16 h-16 text-warning-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <h1 className="text-3xl font-bold text-neutral-900 dark:text-white mb-4">Account Verification Pending</h1>
                    <p className="text-xl text-neutral-600 dark:text-neutral-400 mb-8">
                        Thank you for completing your instructor onboarding! Our admin team is reviewing your qualifications.
                    </p>
                    <div className="bg-neutral-50 dark:bg-neutral-700/50 rounded-lg p-6 mb-8">
                        <h2 className="text-lg font-semibold text-neutral-900 dark:text-white mb-4">What to expect:</h2>
                        <ul className="text-left space-y-3 text-neutral-600 dark:text-neutral-400">
                            <li className="flex items-start">
                                <span className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3"></span>
                                <span>Review process typically takes 1-3 business days</span>
                            </li>
                            <li className="flex items-start">
                                <span className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3"></span>
                                <span>You'll receive an email notification once your account is approved</span>
                            </li>
                            <li className="flex items-start">
                                <span className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3"></span>
                                <span>You can check your verification status at any time by refreshing this page</span>
                            </li>
                        </ul>
                    </div>
                    <div className="space-y-4">
                        <p className="text-neutral-600 dark:text-neutral-400">
                            If you have any questions or need assistance, please contact our support team.
                        </p>
                        <button
                            onClick={() => navigate('/help-support')}
                            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                        >
                            Contact Support
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InstructorPendingVerificationPage;